/*
  «Сверить все» в сверке скана - решение владельца 19.10.2026, макет
  «2-сверить-все-А».

  Сначала спрашивает сервер, что подтвердится (окно показывает числа и
  причины до нажатия), потом подтверждает и запоминает итог: он остаётся на
  экране списком страниц, которые программа подтвердить не смогла.

  Правило годности страницы на сервере одно на сверку по одной и на эту
  кнопку - клиент его не повторяет и ничего не решает сам.
*/

import { useState } from 'react'

import { api } from '../../api/client.js'

const IDLE = { plan: null, result: null, busy: false, error: null, askError: null }

export default function useConfirmAll(fileId, onDone) {
  const [state, setState] = useState(IDLE)

  // Окно открывается, когда сервер назвал числа; ошибка - у кнопки, окна ещё нет.
  const ask = async () => {
    setState((current) => ({ ...current, busy: true, askError: null }))
    try {
      const plan = await api.scanConfirmPlan(fileId)
      setState((current) => ({ ...current, plan, busy: false }))
    } catch (error) {
      setState((current) => ({ ...current, busy: false, askError: error }))
    }
  }

  // Ошибка подтверждения - внутри окна, рядом с кнопкой, которую нажали.
  const confirm = async () => {
    setState((current) => ({ ...current, busy: true, error: null }))
    try {
      const result = await api.confirmAllScanPages(fileId)
      setState({ ...IDLE, result })
      await onDone?.()
    } catch (error) {
      setState((current) => ({ ...current, busy: false, error }))
    }
  }

  // Закрытое окно не хранит прошлую ошибку - следующее открытие начинается чисто.
  const cancel = () => setState((current) => ({ ...current, plan: null, error: null }))

  return { ...state, ask, confirm, cancel }
}
